module.exports = __webpack_public_path__ + "img/32400.242ea7d6.jpg";